import PageLoad from './PageLoad'
import NavigationEvent from './NavigationEvent'

export default {
    PageLoad,
    NavigationEvent
}